import {PageItem_HeadlineContentBlock} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.types';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  SPACING,
  gridCols,
  mediaLargeScreens,
  mediaTabletAndUp,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {HEADLINE_BLOCK} from './StoryText';

export const StoryHeadline: React.FC<{
  content: PageItem_HeadlineContentBlock;
  testId?: string;
}> = ({content, testId = 'storyHeadline'}) => {
  if (content.text === '') return null;

  return (
    <Headline data-block={HEADLINE_BLOCK} data-testid={testId}>
      {content.text}
    </Headline>
  );
};

const Headline = styled.h2`
  margin: 0;
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px32};
  font-weight: ${FONT_WEIGHTS.w700};
  line-height: 2.5rem;
  text-align: center;
  word-break: break-word;

  @media ${mediaTabletAndUp} {
    font-size: ${FONT_SIZES.px40};
    line-height: 2.75rem;
  }

  @media ${mediaLargeScreens} {
    ${gridCols(6)}
    padding-inline: ${SPACING['X.Lg']};
    margin-inline: auto;
  }
`;
